/*
 * @Date: 2022-11-01 14:38:51
 * @LastEditors: kinfai
 * @Description: 
 * @LastEditTime: 2022-11-03 11:35:52
 * @FilePath: \chatPlugin\src\hooks\turms\index.js
 */
import { useContext } from "react";
import { TurmsContext } from "@/provide/turms-context.js";
import useTourists from "@/hooks/tourists/index.js";

export default function useTurms() {
    // console.log("环境变量", process.env.REACT_APP_TURMS_IM, "ws://192.168.2.31:10510")
    const url = process.env.REACT_APP_TURMS_IM + '/'
    const { getTouristsId } = useTourists()

    // 确保该资源加载完毕~
    const awaitLoadTurms = () => {
        let timer = null
        return new Promise(resolve => {
            timer = setInterval(() => {
                if (window.TurmsClient) {
                    clearInterval(timer)
                    resolve()
                }
            }, 500)
        })
    }

    // 初始化构建
    const initTurms = async () => {
        if (window.turmsClient) {
            return window.turmsClient
        }

        await awaitLoadTurms()

        const userId = await getTouristsId()
        const turmsClient = new window.TurmsClient(url, 30 * 1000)
        // const turmsClient = new window.TurmsClient({
        //     useSharedContext: true,
        //     connectionTimeout: 30 * 1000,
        //     wsUrl: url
        // })

        turmsClient.userService.addOnOfflineListener(msg => {
            console.log("onoffline", msg)
        })
        turmsClient.notificationService.addNotificationListener(msg => {
            console.log('notification', msg)
        })
        turmsClient.messageService.addMessageListener(msg => {
            console.log('msg', msg)
        })

        await turmsClient.userService.login({
            userId
        }).catch(err => {
            console.log("trums创建失败", err)
        })

        window.turmsClient = turmsClient

        return turmsClient
    }

    // 获取turms
    const turmsContext = useContext(TurmsContext)
    const getTurms = () => {
        return turmsContext.trumsClient
    }

    // 向指定客服发送消息
    const sendMessageToCs = async (targetId, text, messageType = 0) => {
        const turms = getTurms()
        if (!turms) {
            return new Error("未初始化~")
        }

        return turms.messageService.sendMessage({
            isGroupMessage: false,
            targetId, text, messageType
        })
    }

    return {
        initTurms,
        getTurms,
        sendMessageToCs
    }
}
